// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Button_Wrapper__QmTcQ","Box":"Button_Box__2imEP","FrontBtn":"Button_FrontBtn__1_xKy"};